export default __webpack_public_path__ + "static/media/menu_gasdaysummaryreport_selected.7c9046e8.svg";